import { HttpContextToken, HttpRequest } from '@angular/common/http';

export const SkipByAuthInterceptorContext = new HttpContextToken(() => true);

export const isSkippedByAuthInterceptorContext = <Body>(
  request: HttpRequest<Body>,
): boolean => {
  return request.context.has(SkipByAuthInterceptorContext);
};
